// extracted by mini-css-extract-plugin
module.exports = {"button":"Navbar_button__2ot-4"};